import { CONFIG } from 'config/config';

import styled from 'styled-components/macro';

export const SliderItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`;
export const SummaryItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin-bottom: 5px;
`;
export const SliderDots = styled.div`
	margin-top: 10px;
	display: grid;
	gap: 10px;
	grid-template-columns: repeat(4, 1fr);
`;
export const SliderDot = styled.div`
	border-radius: 50%;
	height: 8px;
	width: 8px;
	background-color: ${(props) => {
		if (props.selected) {
			return CONFIG.colors.primary;
		} else {
			return CONFIG.colors.grey;
		}
	}};
`;
export const IconContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 24px;
	height: 24px;
	cursor: pointer;
`;

export const SpinnerContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 80px;
	height: 80px;
`;
